module.exports = __webpack_public_path__ + "src/assets/textures/logo.png";